import TableRow from '@material-ui/core/TableRow';
import styled from 'styled-components';

const AmpTableRow = styled(TableRow)`
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  @supports (-ms-ime-align:auto) {
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.15);
    outline: 1px solid rgba(0, 0, 0, 0.04);
  }
  &:hover {
    background-color: ${props => props.clickable && 'rgba(0, 0, 0, 0.02)'};
  }
  cursor: ${props => props.clickable && 'pointer'};
  & > td:first-child {
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  & > td:last-child {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

AmpTableRow.defaultProps = {
  clickable: true,
};

export default AmpTableRow;
